module.exports = __webpack_public_path__ + "static/media/3ds.f733a760.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/3ds.png
// module id = 141
// module chunks = 0